import { useMemo, useState } from 'react'
import useBalances from './useBalances'
import { useTranslation } from 'react-i18next'
import { approveToken } from '../handlers/walletActions/wallet'
import { decimalsToE8s } from '../utils/validationHelper'
import { TOP_UP_CANISTER_ID } from '../clients/TopUp'
import { ICToken } from '../interfaces/common'
import { TCYCLES_CANISTER_ID } from '../constants/canisterIds'

const useCyclesApprove = () => {
  const [amount, setAmount] = useState<string>('')
  const [approveLoading, setApproveLoading] = useState(false)

  const { t } = useTranslation()

  const { findBalance } = useBalances()

  const walletCyclesBalance = findBalance({ address: TCYCLES_CANISTER_ID })
  const tcyclesToken = walletCyclesBalance?.token as ICToken | undefined

  const approve = async () => {
    if (!tcyclesToken) return

    setApproveLoading(true)

    try {
      const approveResponse = await approveToken({
        tokenCanisterId: tcyclesToken.address,
        standard: tcyclesToken.standard,
        amount: decimalsToE8s(amount || '', tcyclesToken.decimals),
        spender: {
          address: TOP_UP_CANISTER_ID,
        },
      })

      setApproveLoading(false)
      return approveResponse
    } finally {
      setApproveLoading(false)
    }
  }

  const error = useMemo(() => {
    if (!tcyclesToken) return
    if (!Number(amount)) return t('send.errors.noAmount')
  }, [amount, walletCyclesBalance])

  return {
    amount,
    setAmount,
    walletCyclesBalance,
    approve,
    error,
    approveLoading,
  }
}

export default useCyclesApprove
